import { Chip, useTheme } from '@mui/material';
import {
  applyInverseScale,
  BenchmarkData,
  calculateDelta,
  DisplayMetric,
} from '@strength/domain-workout';

export const baseTabletChipStyle = {
  mx: 1,
  height: 20,
  '.MuiChip-label': {
    px: 1,
  },
};

type DeltaIndicatorProps = {
  metric: DisplayMetric;
  prescribed?: string;
  actual?: string;
  benchmarkData?: BenchmarkData;
};

export const DeltaIndicator = ({
  metric,
  prescribed,
  actual,
  benchmarkData,
}: DeltaIndicatorProps) => {
  const {
    palette: { success, error },
  } = useTheme();
  const delta = calculateDelta(metric, prescribed, actual, benchmarkData);
  if (!delta) {
    return null;
  }

  // Orient the color by the metric's direction: for an inverse-scale metric a
  // lower actual (negative raw delta) is the improvement, so it must read green.
  // The raw signed label below is unaffected.
  const orientedDelta = applyInverseScale(
    delta,
    metric.config?.isInverseScale ?? false,
  );

  return (
    <Chip
      sx={{
        backgroundColor: orientedDelta > 0 ? success.lighter : error.lighter,
        ...baseTabletChipStyle,
      }}
      label={`${delta > 0 ? '+' : ''}${delta}`}
    />
  );
};
